import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=54e626c0&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=ts&"
export * from "./Advertisement.vue?vue&type=script&lang=ts&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=54e626c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e626c0",
  null
  
)

export default component.exports